import * as React from "react";
import {
  Provider as PaperProvider,
  Text,
  DefaultTheme,
  IconButton,
} from "react-native-paper";
import {
  StyleSheet,
  View,
  ScrollView,
  Image,
  ImageBackground,
} from "react-native";
import { whiteColor, blackColor, greenBold } from "./../../common/colors";
import Button from "./../../common/Button";
import routes from "./../../routing/routes";
import Icon from "react-native-vector-icons/AntDesign";
import useKeypress from "react-use-keypress";
import { connect } from "react-redux";
import ModalHeader from "../../common/ModalHeader";
import screenBackground from "./../Images/firstScreenBackground.png";
import displayName from "../../common/displayName";
import t from '../../translations';

const WelcomeTest = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const back = () => {
    props.onClose();
  };
  const close = () => {
    props.onClose();
  };

  return (
    <PaperProvider theme={theme}>
      <View style={styles.wrapper}>
        <View style={styles.containerButtons}>
          <ModalHeader back={back} close={close} isButtonBackHidden={true} />
        </View>
        <ImageBackground
          source={screenBackground}
          style={styles.screenBackground}
        >
          <View style={styles.container}>
            <ScrollView style={styles.scrollView}>
              <View style={styles.manywords}>
                <Text style={styles.title}>
                  {t('welcomeTest_hello')}, {displayName(props.user)}!
                </Text>
                <Text style={styles.contentContainer}>
                {t('welcome_secondLine')}
                  <Text style={styles.greenbold}>
                    {" "}
                    {t('welcome_thirdLine')}<Text> </Text>
                  </Text>
                  {t('welcome_forthLine')}
                </Text>
                <Text style={styles.contentContainer}>
                {t('welcome_description_part1')} <Text style={styles.greenbold}> {t('welcome_description_part2')}</Text>, 
                {t('welcome_description_part3')}
                </Text>
                <Text style={styles.contentContainer}>
                {t('welcome_description2_part1')}
                  <Text style={styles.greenbold}>  {t('welcome_description2_part2')} </Text> {t('welcome_description2_part3')}
                  <Text style={styles.greenbold}>
                    {" "}
                    {t('welcome_description2_part4')}
                  </Text>{" "}
                  {t('welcome_description2_part5')}
                </Text>
                <View style={styles.buttonContainer}>
                  <Button onPress={props.navigate} value={t('welcome_button')} />
                </View>
              </View>
            </ScrollView>
          </View>
        </ImageBackground>
      </View>
    </PaperProvider>
  );
};
const mapStateToProps = (state) => {
  const user = state.user;

  return { user };
};
export default connect(mapStateToProps)(WelcomeTest);

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 35,
    width: "100%",
    backgroundColor: whiteColor,
  },
  back: {
    paddingRight: 100,
    alignItems: "flex-end",
    display: "flex",
  },
  close: {
    paddingLeft: 200,
    paddingRight: 100,
  },
  icons: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: 0,
  },
  iconItemLeft: {
    width: "50%",
    alignItems: "flex-start",
  },
  iconItemRight: {
    width: "50%",
    alignItems: "flex-end",
  },
  containerButtons: {
    backgroundColor: whiteColor,
    width: 360,
    alignItems: "center",
    alignContent: "flex-start",
    justifyContent: "flex-start",
  },
  container: {
    backgroundColor: whiteColor,
    width: 360,
    alignItems: "center",
    alignContent: "flex-start",
    justifyContent: "flex-start",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  screenBackground: {
    flex: 1,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    textAlign: "left",
    fontSize: 24,
    paddingBottom: 24,
    paddingTop: 24,
    textTransform: "uppercase",
  },
  headermessage: {
    textAlign: "left",
    fontSize: 14,
    padding: 6,
    lineHeight: 18.75,
    letterSpacing: 1.25,
    paddingRight: 48,
    paddingLeft: 0,
    paddingTop: 24,
    paddingBottom: 24,
  },
  manywords: {
    paddingLeft: 26,
    paddingRight: 26,
    paddingBottom: 26,
    alignItems: "stretch",
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 30,
  },
  contentContainer: {
    textAlign: "left",
    fontSize: 13,
    padding: 0,
    lineHeight: 22,
    letterSpacing: 1.25,
    paddingRight: 0,
    paddingLeft: 0,
    paddingBottom: 2,
    paddingTop: 18,
  },
  buttonContainer: {
    alignItems: "center",
    paddingTop: 60,
    paddingBottom: 20,
  },
  greenbold: {
    color: greenBold,
    fontWeight: "700",
  },
});
